import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiHome, FiUser,FiMap, FiLogOut } from 'react-icons/fi';


// Define props for the Sidebar component
interface SidebarProps {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>; // Type for state setter
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, setIsCollapsed }) => {
  const menuItems = [
    { name: 'Dashboard', icon: <FiHome />, path: '/admin/dashboard' },
    { name: 'Properties', icon: <FiMap />, path: '/admin/properties' },
    { name: 'Profile', icon: <FiUser />, path: '/admin/profile' },
  ];


  const handleLogout = () => {
    fetch('https://akjodem.com/logout.php', {
      credentials: 'include', // Include session cookies
    })
      .then((response) => response.json()) // Parse the JSON response
      .then((data) => {
        if (data.status === 'success') {
          localStorage.removeItem('akjodem_email');
          localStorage.removeItem('akjodem_isLoggedIn');
          window.location.reload()
        } else {
          console.error('Logout failed:', data.message);
        }
      })
      .catch((error) => {
        console.error('Error during logout:', error);
      });
  };
  

  return (
    <div
      className={`fixed bg-gray-800 h-screen text-white transition-all duration-300 ${
        isCollapsed ? 'w-20' : 'w-64'
      }`}
    >
      {/* Toggle Button */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="p-4 focus:outline-none text-gray-300"
      >
        <FiMenu size={24} />
      </button>

      <div className="p-4 font-bold text-lg whitespace-nowrap">
        {!isCollapsed && 'Real Estate Admin'}
      </div>

      {/* Menu Items */}
      <nav className="mt-4">
        {menuItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-4 p-4 ${
                isActive ? 'bg-gray-700' : 'hover:bg-gray-600'
              }`
            }
          >
            {item.icon}
            {!isCollapsed && <span>{item.name}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="bottom-4 absolute w-full">
        <button
          onClick={handleLogout}
          className="flex items-center gap-4 hover:bg-gray-600 p-4 w-full"
        >
          <FiLogOut />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
